import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useAlert } from "./contexts/AlertContext";
import Navbar from "./Components/LandingComponents/LandingNavbar";
import AlertComponent from "./Components/LandingComponents/LandingAlertComponent";
import Documentation from "./Components/LandingComponents/LandingDocumentation";
import About from "./Components/LandingComponents/LandingAbout";
import SignUp from "./Components/LandingComponents/SignUp";
import Login from "./Components/LandingComponents/LandingLogin";
import PrivateRoute from "./Components/LandingComponents/PrivateRoute";
import ProfileComponent from "./Components/LandingComponents/ProfileComponent";
import PageNotFound from "./Components/LandingComponents/LandingPageNotFound";
import Footer from "./Components/LandingComponents/LandingFooter";
import GoToTop from "./Components/LandingComponents/LandingGoToTop";
import Editor from "./Components/EditorComponents/RenderCompnent/Editor";
import MobileRestricted from "./Components/LandingComponents/MobileRestricted";
import LandingHomePage from "./Components/LandingComponents/LandingHomePage";
import "./App.css";

const App = () => {
  const { alert } = useAlert();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 800);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hideNavbar = location.pathname === "/editor";
  const hideGotoTop = location.pathname === "/editor";

  return (
    <React.Fragment>
      {!hideNavbar && <Navbar />}

      {alert && (
        <AlertComponent
          title={alert.title}
          message={alert.message}
          variant={alert.variant}
          duration={alert.duration}
        />
      )}

      <Routes>
        <Route path="/" element={<LandingHomePage />} />
        <Route path="/home" element={<LandingHomePage />} />
        <Route path="/documentation" element={<Documentation />} />
        <Route path="/about" element={<About />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<Login />} />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <ProfileComponent />
            </PrivateRoute>
          }
        />
        <Route
          path="/editor"
          element={
            <PrivateRoute>
              {isMobile ? <MobileRestricted /> : <Editor />}
            </PrivateRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      {!hideNavbar && <Footer />}

      {!hideGotoTop && <GoToTop />}
    </React.Fragment>
  );
};

export default App;
